import NewDeliveredOrder from '../components/delivered_orders/new_delivered_order.vue'
import DeliveredOrdersTable from '../components/delivered_orders/delivered_orders_table.vue'

export default {
  components: {
    NewDeliveredOrder,
    DeliveredOrdersTable
  },
  data: () => ({
  })
}